import React, {Component} from 'react'
import { Route } from "react-router-dom";
import TransitionGroup from "react-transition-group/TransitionGroup";
import AnimatedSwitch from "./utils/animated_switch";
import Header from "./components/header";
import Home from "./home";
import About from "./about";
import Contact from "./contact";
import Work from "./work";
import Hoven from "./hoven";
import Hyperlite from "./hyperlite";
import Hosports from "./hosports";
import Threadloom from "./threadloom";
import Soeventful from "./soeventful";
import Thankyou from "./thankyou";
import Services from "./services";
import DataPolicy from "./dataPolicy";
import PrivacyPolicy from "./privacyPolicy";
import {initPage} from "./utils/utilities";

export default class App extends Component {
  headerScrollHandler(data){
    var heroHeight = 0;
    if(document.getElementsByClassName('ready')[0]){
      heroHeight = document.getElementsByClassName('ready')[0].clientHeight - document.getElementById("header").clientHeight;
	  if(window.outerWidth <= 800){
		  heroHeight = 50;
	  }
    }
    var el = document.getElementById('main-window');
    var value = el.scrollTop;
    if(heroHeight){
      if(value > heroHeight){
        document.getElementById("header").classList.add("active");
      }
      if(value < heroHeight){
        document.getElementById("header").classList.remove("active");
      }

      var target = document.getElementById("hero-parallax");
      if(target){
        target.setAttribute("style","transform: translate3d(0px, "+(-1*value)/5+"px, 0px);");
      }
    }
    var target = document.getElementById("parallax-collage-1");
    if(target){
      var sectionTop = document.getElementById("parallax-collage-1").offsetTop-window.innerHeight;
      if (value > sectionTop){
        var parallaxValue= value-sectionTop;
        document.getElementById("parallax-collage-1");
        document.getElementById("parallax-collage-1-image-1").setAttribute("style","transform: translate3d(0px, "+(-1*parallaxValue)/20+"px, 0px);");
        document.getElementById("parallax-collage-1-image-2").setAttribute("style","transform: translate3d(0px, "+(-1*parallaxValue)/4+"px, 0px);");
        document.getElementById("parallax-collage-1-content").setAttribute("style","transform: translate3d(0px, "+(-1*parallaxValue)/12+"px, 0px);");
      }

    }
    var target2 = document.getElementById("photo-grid-collage");
    if(target2){
      console.log(value)
      var section2Top = document.getElementById("photo-grid-collage").offsetTop-window.innerHeight;
      if (value > section2Top){
        var parallaxValue= value-section2Top;
        document.getElementById("photo-grid-collage-1").setAttribute("style","transform: translate3d(0px, "+(-1*parallaxValue)/20+"px, 0px);");
        document.getElementById("photo-grid-collage-2").setAttribute("style","transform: scale(1.1) translate3d(0px, "+(-1*parallaxValue)/30+"px, 0px);");
        document.getElementById("photo-grid-collage-3").setAttribute("style","transform: scale(1.3) translate3d(0px, "+(-1*parallaxValue)/10+"px, 0px);");
        document.getElementById("photo-grid-collage-4").setAttribute("style","transform: scale(1.3) translate3d(0px, "+(-1*parallaxValue)/20+"px, 0px);");
      }

    }
    var target3 = document.getElementById("scroll-highlight-text");
    if(target3){
      var rows = document.getElementsByClassName("scroll-highlight-text-item");
      for (var i=0, item; item = rows[i]; i++) {
        // Look no need to do list[i] in the body of the loop
        if(value > item.offsetTop-(window.innerHeight/2)){
          item.classList.add("active");
        }
        else{
        item.classList.remove("active");
        }
      }
    }
  }
  render() {
		return (
			<div className="wrapper">
        <Header />
				<Route
					render={({ location }) => (
						<TransitionGroup component="main" onScroll={this.headerScrollHandler}>
							<AnimatedSwitch key={location.key} location={location}>
								<Route exact path="/" render={props => (<Home />)} />
                <Route exact path="/work" render={props => (<Work />)} />
                <Route exact path="/thankyou" render={props => (<Thankyou />)} />
                <Route exact path="/hoven" render={props => (<Hoven />)} />
                <Route exact path="/hyperlite" render={props => (<Hyperlite />)} />
                <Route exact path="/hosports" render={props => (<Hosports />)} />
                <Route exact path="/threadloom" render={props => (<Threadloom />)} />
                <Route exact path="/soeventful" render={props => (<Soeventful />)} />
                <Route exact path="/about" render={props => (<About />)} />
                <Route exact path="/services" render={props => (<Services />)} />
                <Route exact path="/contact" render={props => (<Contact />)} />
                <Route exact path="/dataPolicy" render={props => (<DataPolicy />)} />
                <Route exact path="/privacyPolicy" render={props => (<PrivacyPolicy />)} />
							</AnimatedSwitch>
						</TransitionGroup>
					)}
    />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app.js